/* CUSTOM-KIRN: Web3Forms submission handler.
 *
 * Any <form data-kirn-form> on the site is intercepted: instead of
 * submitting via Shopify's contact endpoint, the FormData is POSTed
 * to https://api.web3forms.com/submit which forwards the submission
 * by email to the address verified against the access_key.
 *
 * The access_key comes from theme settings (Online Store -> Themes ->
 * Customize -> Theme settings -> Kirn — Forms). When unset, JS shows
 * a soft fallback message instead of submitting.
 */
(() => {
  const ENDPOINT = 'https://api.web3forms.com/submit';

  const init = () => {
    document.querySelectorAll('[data-kirn-form]').forEach(wire);
  };

  const wire = (form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const accessInput = form.querySelector('input[name="access_key"]');
      const accessKey = accessInput ? accessInput.value.trim() : '';
      if (!accessKey || accessKey === 'YOUR_ACCESS_KEY') {
        showError(
          form,
          'The contact form is not yet configured. Please email hello@kirncoffee.co.uk and we will get back to you.',
        );
        return;
      }

      const submit = form.querySelector('[type="submit"]');
      const submitLabel = submit ? submit.textContent : null;
      if (submit) {
        submit.disabled = true;
        submit.dataset.kirnBusy = '1';
        submit.textContent = 'Sending…';
      }

      hideMessages(form);

      try {
        const response = await fetch(ENDPOINT, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        const result = await response.json();
        if (response.ok && result.success) {
          showSuccess(form);
          form.reset();
        } else {
          throw new Error(result.message || 'Submission failed. Please try again.');
        }
      } catch (err) {
        showError(form, err.message || 'Network error. Please try again.');
      } finally {
        if (submit) {
          submit.disabled = false;
          delete submit.dataset.kirnBusy;
          if (submitLabel) submit.textContent = submitLabel;
        }
      }
    });
  };

  const hideMessages = (form) => {
    form.querySelectorAll('[data-kirn-form-success], [data-kirn-form-error]').forEach(
      (el) => el.setAttribute('hidden', ''),
    );
  };

  const showSuccess = (form) => {
    hideMessages(form);
    const el = form.querySelector('[data-kirn-form-success]');
    if (el) el.removeAttribute('hidden');
  };

  const showError = (form, message) => {
    hideMessages(form);
    const el = form.querySelector('[data-kirn-form-error]');
    if (el) {
      el.removeAttribute('hidden');
      const slot = el.querySelector('[data-kirn-form-error-message]');
      if (slot) slot.textContent = message;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
